/**
 * GlowText.tsx — Glow neon por letra (Claude Design).
 *
 * Parte o texto em <span class="ltr"> por caractere para que o hover-glow.css
 * acenda cada letra no :hover (laranja para corpo, verde para títulos via
 * ancestral .glow-title). Abordagem React-safe: gera spans no render, sem
 * mutar o DOM manualmente (evita quebrar a reconciliação do React).
 *
 * Uso:
 *   <GlowText>{t('login.subtitle')}</GlowText>          // corpo (laranja)
 *   <span className="glow-title"><GlowText>Título</GlowText></span>  // verde
 */
import React from 'react';

interface GlowTextProps {
  children: string | number;
}

export function GlowText({ children }: GlowTextProps): React.ReactElement {
  const text = String(children ?? '');
  return (
    <>
      {Array.from(text).map((ch, i) => {
        // Preserva espaços (inclui &nbsp; 160) como texto puro — não acende
        if (/\s/.test(ch) || ch.charCodeAt(0) === 160) {
          return ch;
        }
        return (
          <span key={i} className="ltr">
            {ch}
          </span>
        );
      })}
    </>
  );
}
